<template>
  <v-dialog v-model="importDialog.open" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t("dangerousGoods.dangerousGoodsList.import.title") }}
      </v-card-title>
      <v-card-text
        v-html="$t('dangerousGoods.dangerousGoodsList.import.info')"
      ></v-card-text>
      <div class="ml-6 mb-4">
        <div class="subtitle-1 mt-5">{{ $t("examination.addFile") }}</div>
        <input
          @change="handleFile"
          class="mt-2"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">
          {{ $t("general.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          text
          :loading="loading"
          @click="$emit('triggerUpload', file)"
          data-cy="importDangerousGood"
        >
          {{ $t("general.import") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["importDialog", "loading"],
  data() {
    return {
      file: {
        filetype: null,
        name: null,
        content: null,
      },
    };
  },
  methods: {
    close() {
      this.importDialog.open = false;
      this.file = { filetype: null, name: null, content: null };
    },
    handleFile(e) {
      const selected = e.target.files[0];
      if (!selected) return;
      const reader = new FileReader();
      reader.onload = (event) => {
        const match = selected.name.match(/\.[0-9a-z]+$/i);
        this.file.filetype = match ? match[0].split(".")[1] : null;
        this.file.name = selected.name;
        this.file.content = event.target.result.split(",")[1];
      };
      reader.readAsDataURL(selected);
    },
  },
};
</script>
